/** Light-theme stars — 131×23, gold #CC8F02 */
export const BrokingHeroStars = () => (
    <svg
        className="h-[23px] w-[131px] shrink-0"
        viewBox="0 0 131 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path
            d="M11.5 0L14.0819 7.9463H22.4371L15.6776 12.8574L18.2595 20.8037L11.5 15.8926L4.74047 20.8037L7.32238 12.8574L0.56285 7.9463H8.91809L11.5 0Z"
            fill="#CC8F02"
        />
        <path
            d="M38.5 0L41.0819 7.9463H49.4371L42.6776 12.8574L45.2595 20.8037L38.5 15.8926L31.7405 20.8037L34.3224 12.8574L27.5628 7.9463H35.9181L38.5 0Z"
            fill="#CC8F02"
        />
        <path
            d="M65.5 0L68.0819 7.9463H76.4371L69.6776 12.8574L72.2595 20.8037L65.5 15.8926L58.7405 20.8037L61.3224 12.8574L54.5628 7.9463H62.9181L65.5 0Z"
            fill="#CC8F02"
        />
        <path
            d="M92.5 0L95.0819 7.9463H103.437L96.6776 12.8574L99.2595 20.8037L92.5 15.8926L85.7405 20.8037L88.3224 12.8574L81.5628 7.9463H89.9181L92.5 0Z"
            fill="#CC8F02"
        />
        <path
            d="M119.5 0L122.082 7.9463H130.437L123.678 12.8574L126.26 20.8037L119.5 15.8926L112.74 20.8037L115.322 12.8574L108.563 7.9463H116.918L119.5 0Z"
            fill="#E6E6E6"
        />
        <path d="M119.5 16V0L117 8H108.5L115.5 13L112.5 21L119.5 16Z" fill="#CC8F02" />
    </svg>
);

/** shield-check — 20×20, black stroke for light bg (visible on mobile) */
export const BrokingShieldCheckIcon = () => (
    <svg
        className="size-5 shrink-0"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path
            d="M7.16667 10.1667L8.83333 11.8333L12.1667 8.5M16.3333 11C16.3333 15.1667 13.4167 17.25 9.95 18.4583C9.76847 18.5199 9.57128 18.5169 9.39167 18.45C5.91667 17.25 3 15.1667 3 11V5.16667C3 4.94565 3.0878 4.73369 3.24408 4.57741C3.40036 4.42113 3.61232 4.33333 3.83333 4.33333C5.5 4.33333 7.58333 3.33333 9.03333 2.06667C9.20988 1.91583 9.43446 1.83333 9.66667 1.83333C9.89887 1.83333 10.1235 1.91583 10.3 2.06667C11.7583 3.34167 13.8333 4.33333 15.5 4.33333C15.721 4.33333 15.933 4.42113 16.0893 4.57741C16.2455 4.73369 16.3333 4.94565 16.3333 5.16667V11Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

/** chart-line — 20×20, black stroke for light bg (visible on mobile) */
export const BrokingChartLineIcon = () => (
    <svg
        className="size-5 shrink-0"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path
            d="M2.5 2.5V15.8333C2.5 16.2754 2.6756 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H17.5M15.8333 7.5L11.6667 11.6667L8.33333 8.33333L5.83333 10.8333"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

/** trending-up — outer 16×16 */
export const TrendingUpIcon = () => (
    <span className="relative inline-block size-4 shrink-0 overflow-hidden" aria-hidden>
        <span className="absolute inset-[29.17%_8.33%]">
            <span className="absolute inset-[-9.38%_-4.69%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 14.5833 7.91667"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13.9583 0.625L8.29167 6.29167L4.95833 2.95833L0.625 7.29167M13.9583 4.625V0.625H9.95833"
                        stroke="#0DCC54"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

/** trending-down — outer 16×16 */
export const TrendingDownIcon = () => (
    <span className="relative inline-block size-4 shrink-0 overflow-hidden" aria-hidden>
        <span className="absolute inset-[29.17%_8.33%]">
            <span className="absolute inset-[-9.38%_-4.69%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 14.5833 7.91667"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13.9583 7.29167L8.29167 1.625L4.95833 4.95833L0.625 0.625M13.9583 3.29167V7.29167H9.95833"
                        stroke="#FF0303"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

/** Desktop wave arches — #E6E6E6 @ 0.51 on light bg (Figma 1916:1088) */
export const BrokingHeroWaveWeb = () => (
    <svg
        width="1490"
        height="1500"
        viewBox="0 0 1490 1500"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            opacity="0.51"
            d="M1489.75 0H744.875L9.15527e-05 0.000823975L0 755.323V1499.65H705.875H1489.75L1489.75 755.323L1489.75 0ZM1489.75 0L1489.75 176.519C1045.29 257.132 677.219 559.05 502.298 964.956C381.417 796.738 204.978 671.559 0 616.724L9.15527e-05 0.000823975L1489.75 0ZM0 915.037C229.935 1008.21 392.377 1234.76 392.377 1499.65H0V915.037ZM673.855 1499.65C673.855 996.087 1022.28 574.561 1489.75 465.765V1499.65H673.855Z"
            fill="#E6E6E6"
        />
    </svg>
);

/** Mobile wave — Figma 2541:36003, #E6E6E6 @ 0.51 (1043×1080) */
export const BrokingHeroWaveMobile = ({ className }: { className?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1043"
        height="1080"
        viewBox="0 0 1043 1080"
        fill="none"
        className={className}
        aria-hidden
    >
        <path
            opacity="0.51"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1043 0H0V1080H1043V0ZM918.488 128.929V225.701C681.608 269.895 485.442 435.413 392.217 657.941C327.792 565.72 233.757 497.093 124.512 467.032V128.929H918.488ZM124.512 630.574C247.058 681.655 333.633 805.853 333.633 951.071H124.512V630.574ZM483.649 951.071C483.649 675.008 669.348 443.917 918.488 384.273V951.071H483.649Z"
            fill="#E6E6E6"
        />
    </svg>
);
